<div id="tabRetInt">
  <div class="tituloInt tituloPago">{{ 'MOVIMIENTOS_CAJA' | translate }}</div>
  <fieldset>
    <div class="ButtonWrap" *ngIf="tienePermiso('TurnoRetirarDinero')">
      <a class="GestionarButton aceptar" title="{{ 'RETIRAR' | translate }}" (click)="retirar()">{{ 'RETIRAR' | translate }}</a>
    </div>
    <div class="ButtonWrap" *ngIf="tienePermiso('TurnoIntroducirDinero')">
      <a class="GestionarButton aceptar" title="{{ 'INTRODUCIR' | translate }}" (click)="introducir()">{{ 'INTRODUCIR' | translate }}</a>
    </div>
  </fieldset>
</div>
